export function listeningRenderer(param: { value: boolean }) {
  const { value } = param;

  if (value) {
    return "<span class='fa fa-headphones'></span>";
  }

  return '';
}
